import { openDB } from 'idb'

export const dbPromise = async (dbName: string, storeName: string) =>
  await openDB(dbName, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(storeName)) {
        db.createObjectStore(storeName, {
          keyPath: 'key',
        })
      }
    },
  })
